<template>
  <div class="columns">
    <div class="column">
      <Breadcrumbs :links="links" />
      Divisions admin page
    </div>
  </div>
</template>

<script>
const Breadcrumbs = () => import('@/components/admin/Breadcrumbs')

export default {
  name: 'History',
  components: {
    Breadcrumbs
  },
  data () {
    return {
      links: [
        {
          label: 'Dashboard',
          routeName: 'admin-dashboard',
          isActive: false,
          icon: 'dashboard'
        },
        {
          label: 'History',
          routeName: 'admin-history',
          isActive: true,
          icon: 'history'
        }
      ]
    }
  }
}
</script>
